import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button, Input } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import DateField from '../../../../../components/forms/DateField';
import { FilterOptions } from '../../../../../hooks/useFilters';
import { maintenanceTypes } from '../../../../../utils/SelectorMapping';
import CustomTextDelayInput from '../../../../../components/forms/CustomTextDelayInput';

interface VehicleMaintenanceFiltersProps {
    updateFilters: (filters: any) => void;
    filters: FilterOptions;
    updateFilterOrder?: (field: string, order: 'asc' | 'desc') => void;
}

const VehicleMaintenanceFilters: React.FC<VehicleMaintenanceFiltersProps> = ({ filters, updateFilters, updateFilterOrder }) => {

    // HOOKS

    // RENDER
    return (
        <>
            <CustomTextDelayInput
                id="search_text"
                label="Búsqueda"
                placeholder="Añadir búsqueda..."
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomSelect
                id="type"
                label="Tipo de mantenimiento"
                placeholder="Seleccionar tipo"
                options={maintenanceTypes}
                value={maintenanceTypes.filter((item: any) => filters.filter_filters?.type?.includes(item.value))}
                onChange={(value: any) => updateFilters({ type: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <DateField
                isClearable
                className="w-full"
                label="Rango de fechas"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "date"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Fecha de mantenimiento", value: "date" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <div className="grid grid-cols-2 gap-3">

                <CustomTextDelayInput
                    id="cost_min"
                    label="Coste mínimo"
                    placeholder="Ingrese coste mínimo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ cost_min: null })}
                    suffix="€"
                />
                
                <CustomTextDelayInput
                    id="cost_max"
                    label="Coste máximo"
                    placeholder="Ingrese coste máximo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ cost_max: null })}
                    suffix="€"
                /> 
            </div>

            <CustomTextDelayInput
                id="description"
                label="Descripción"
                placeholder="Buscar en descripción..."
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomSelect
                id="sort"
                label="Ordenar por"
                placeholder="Seleccionar orden"
                options={[
                    { value: 'date_desc', label: 'Fecha (más reciente)' },
                    { value: 'date_asc', label: 'Fecha (más antigua)' },
                    { value: 'cost_desc', label: 'Costo (mayor a menor)' },
                    { value: 'cost_asc', label: 'Costo (menor a mayor)' },
                    { value: 'type_asc', label: 'Tipo (A-Z)' },
                    { value: 'type_desc', label: 'Tipo (Z-A)' },
                    { value: 'createdAt_desc', label: 'Creación (más reciente)' },
                    { value: 'createdAt_asc', label: 'Creación (más antigua)' },
                ]}
                value={filters.filter_order && filters.filter_order.length > 0 ?
                    {
                        value: `${filters.filter_order[0].field}_${filters.filter_order[0].order}`,
                        label: [
                            { value: 'date_desc', label: 'Fecha (más reciente)' },
                            { value: 'date_asc', label: 'Fecha (más antigua)' },
                            { value: 'cost_desc', label: 'Costo (mayor a menor)' },
                            { value: 'cost_asc', label: 'Costo (menor a mayor)' },
                            { value: 'type_desc', label: 'Tipo (A-Z)' },
                            { value: 'type_asc', label: 'Tipo (Z-A)' },
                            { value: 'createdAt_desc', label: 'Creación (más reciente)' },
                            { value: 'createdAt_asc', label: 'Creación (más antigua)' },
                        ].find(option => filters.filter_order && option.value === `${filters.filter_order[0].field}_${filters.filter_order[0].order}`)?.label
                    } : null
                }
                onChange={(value: any) => {
                    if (value && updateFilterOrder) {
                        const [field, order] = value.value.split('_');
                        updateFilterOrder(field, order as 'asc' | 'desc');
                    } else if (!value && updateFilterOrder) {
                        updateFilterOrder("", "asc");
                    }
                }}
                isClearable={true}
            />

        </>
    );
};

export default VehicleMaintenanceFilters;